var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block",style:(_vm.iconStyle)},[(_vm.hasComponentFor)?_c(_vm.iconComponent,{tag:"component"}):_c('v-img',{staticClass:"external-source",attrs:{"eager":"","src":_vm.externalSource,"max-height":_vm.height,"max-width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }